export enum itemsTypes {
  start,
  end,
  process,
  decision,

}
